import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-psa-training',
  templateUrl: './psa-training.component.html',
  styleUrls: ['./psa-training.component.css']
})
export class PsaTrainingComponent implements OnInit {
  title="Form-IV: Form for Training certificate";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/training-details/psa-training/psa-training.component.ts